import { AppConsts } from '@shared/AppConsts';
import { SelectItem } from 'primeng/api';

export class SelectItemSortHelper {

    static translateAndOrderAlphabectically(professions: string[], localization: any): SelectItem[] {
        const items = [];

        professions.forEach(x => {
            items.push(({ label: localization(x), value: x }))
        })

        return items.sort((a, b) => a.label.localeCompare(b.label));
    }

    static translateAndOrderAlphabetically(items: SelectItem[]): SelectItem[] {

        return items.sort((a, b) => a.label.localeCompare(b.label));
    }

    static orderLiaProfessions(items: SelectItem[]): SelectItem[] {

        const order = [
            AppConsts.codes.profession.physician,
            AppConsts.codes.profession.dentist,
            AppConsts.codes.profession.pharmacist,
            AppConsts.codes.profession.chiropractor,
            AppConsts.codes.profession.nursing,
            AppConsts.codes.profession.physiotherapist,
            AppConsts.codes.profession.occupationalTherapist,
            AppConsts.codes.profession.midwife,
            AppConsts.codes.profession.nutritionist,
            AppConsts.codes.profession.optometrist,
            AppConsts.codes.profession.osteopath,
            AppConsts.codes.profession.optician,
            AppConsts.codes.profession.podiatrist,
            AppConsts.codes.profession.druggist,
            AppConsts.codes.profession.dentalHygienist,
            AppConsts.codes.profession.paramedic,
            AppConsts.codes.profession.therapistTCM,
            AppConsts.codes.profession.alternativePractitionerTEN,
            AppConsts.codes.profession.homoeopath,
            AppConsts.codes.profession.psychotherapist
        ];

        return SelectItemSortHelper.orderListOnTop(order, items);
    }

    static getFrequentLanguages(): string[] {
        const languageSkillIds: string[] = [];
        languageSkillIds.push(AppConsts.codes.languageSkill.german,
                              AppConsts.codes.languageSkill.french,
                              AppConsts.codes.languageSkill.italian,
                              AppConsts.codes.languageSkill.other);
        return languageSkillIds;
    }

    static sortLanguages(languageSkills: SelectItem[]): SelectItem[] {
        return SelectItemSortHelper.orderListOnTop(this.getFrequentLanguages(), languageSkills);
    }

    static sortEhcApplicationReleaseAction(actions: SelectItem[]): SelectItem[] {
        const actionIds: string[] = [];

        actionIds.push(AppConsts.codes.applicationReleaseAction.ehcAndLia,
                       AppConsts.codes.applicationReleaseAction.liaOnly,
                       AppConsts.codes.applicationReleaseAction.withdrawAll,
                       AppConsts.codes.applicationReleaseAction.withdrawEhc);

        return SelectItemSortHelper.orderListOnTop(actionIds, actions);
    }

    static getFrenquentCountriesList(): string[] {
        const frenquentCountriesIds: string[] = [];
        frenquentCountriesIds.push(AppConsts.codes.country.ch,
                                    AppConsts.codes.country.de,
                                    AppConsts.codes.country.fr,
                                    AppConsts.codes.country.at,
                                    AppConsts.codes.country.it,
                                    AppConsts.codes.country.nl,
                                    AppConsts.codes.country.gr,
                                    AppConsts.codes.country.be,
                                    AppConsts.codes.country.pl,
                                    AppConsts.codes.country.gb,
                                    AppConsts.codes.country.hu,
                                    AppConsts.codes.country.ro,
                                    AppConsts.codes.country.pt,
                                    AppConsts.codes.country.es,
                                    AppConsts.codes.country.cz,
                                    AppConsts.codes.country.se,
                                    AppConsts.codes.country.sk,
                                    AppConsts.codes.country.bg,
                                    AppConsts.codes.country.fi,
                                    AppConsts.codes.country.lt,
                                    AppConsts.codes.country.hr,
                                    AppConsts.codes.country.lu,
                                    AppConsts.codes.country.li,
                                    AppConsts.codes.country.yu);
        return frenquentCountriesIds;
    }

    static sortCountryByFrequency(allCountries: SelectItem[]): SelectItem[] {
        return SelectItemSortHelper.orderListOnTop(this.getFrenquentCountriesList(), allCountries);
    }


    static getLicenceStatusOrderList(): string[] {
        const ids: string[] = [];
        ids.push(AppConsts.codes.professionalLicenceStatus.granted,
            AppConsts.codes.professionalLicenceStatus.inactive,
            AppConsts.codes.professionalLicenceStatus.noLicence,
            AppConsts.codes.professionalLicenceStatus.refused,
            AppConsts.codes.professionalLicenceStatus.banned,
            AppConsts.codes.professionalLicenceStatus.revoked);
        return ids;
    }

    static sortLicenceStatus(status: SelectItem[]): SelectItem[] {
        return SelectItemSortHelper.orderListOnTop(this.getLicenceStatusOrderList(), status);
    }

    static sortPendenceStatus(status: SelectItem[]): SelectItem[] {
        return SelectItemSortHelper.orderListOnTop(this.getPendenceStatusOrderList(), status);
    }

    static getPendenceStatusOrderList(): string[] {
        const ids: string[] = [];
        ids.push(AppConsts.codes.pendenceStatus.open,
            AppConsts.codes.pendenceStatus.inProcess,
            AppConsts.codes.pendenceStatus.toVerify,
            AppConsts.codes.pendenceStatus.completed);
        return ids;
    }

    static orderListOnTop(itemsOnTop: string[], items: SelectItem[]): SelectItem[] {
        const orderedList: SelectItem[] = [];

        itemsOnTop.forEach(x => {
            const i = items.findIndex(y => y.value === x);
            if (i !== -1) {
                orderedList.push(items[i]);
            }
        });

        items.forEach(x => {
            const i = itemsOnTop.findIndex(y => y === x.value);
            if (i === -1) {
                orderedList.push(x);
            }
        });

        return orderedList;
    }

    static orderListAtBottom(itemsAtBottom: string[], items: SelectItem[]): SelectItem[] {
        const orderedList: SelectItem[] = [];

        items.forEach(x => {
            const i = itemsAtBottom.findIndex(y => y === x.value);
            if (i === -1) {
                orderedList.push(x);
            }
        });

        itemsAtBottom.forEach(x => {
            const i = items.findIndex(y => y.value === x);
            if (i !== -1) {
                orderedList.push(items[i]);
            }
        });

        return orderedList;
    }
}
